// extracted by mini-css-extract-plugin
module.exports = {"container":"Container-module__container___QbI23"};